module.exports = __webpack_public_path__ + "img/ticket-pdf.9a0bb5bc.png";